import { classnames } from 'tailwindcss-classnames';

const QuoteDown = (): JSX.Element => (
  <div className={classnames('absolute', 'left-0', 'bottom-0')}>
    <div className={classnames('svg-sm')}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="65"
        height="168"
        viewBox="0 0 65 168"
        fill="none"
      >
        <path
          d="M-42 126.36C-42 169.471 -15.4345 194 14.8207 194C42.8621 194 65 170.958 65 143.456C65 115.954 45.8138 96.6283 21.4621 96.6283C16.2966 96.6283 10.3931 97.3717 8.91724 98.115C13.3448 72.8429 38.4345 42.3678 62.0483 28.2452L26.6276 0C-13.9586 28.9885 -42 75.0728 -42 126.36Z"
          fill="url(#paint0_linear_3662_1486)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3662_1486"
            x1="-42"
            y1="97.435"
            x2="65"
            y2="97.435"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="var(--color-blue)" />
            <stop offset="0.942708" stopColor="var(--color-dayglow)" />
          </linearGradient>
        </defs>
      </svg>
    </div>
    <div className={classnames('svg-lg')}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="98"
        height="227"
        viewBox="0 0 98 227"
        fill="none"
      >
        <path
          d="M-75 203.218C-75 272.552 -32.0483 312 16.869 312C62.2069 312 98 274.943 98 230.713C98 186.483 66.9793 155.402 27.6069 155.402C19.2552 155.402 9.71035 156.598 7.32414 157.793C14.4828 117.149 55.0483 68.138 93.2276 45.4253L35.9586 0C-29.662 46.6207 -75 120.736 -75 203.218Z"
          fill="url(#paint0_linear_3662_4115)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3662_4115"
            x1="-75"
            y1="156.7"
            x2="98"
            y2="156.7"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="blue" />
            <stop offset="0.942708" stopColor="dayglow" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  </div>
);

export default QuoteDown;
